/**
 * Trần của một khoản trả thẻ/nợ = số còn nợ thực tế của thẻ (dư nợ) hoặc khoản vay (gốc còn lại + lãi một kỳ).
 * Mẫu định kỳ có thể cũ hơn dư nợ (đã trả bớt, đã tất toán): dự báo và ô xác nhận phải theo số còn nợ, không theo mẫu.
 * Trả null khi không phải khoản trả thẻ/nợ hoặc không tìm thấy thẻ/khoản vay.
 */
export const paymentCap = (p: { paymentType?: string; creditCardId?: string; debtId?: string }, sources: any[], debts: any[]): number | null => {
  if (p.paymentType === 'credit') {
    const card = sources.find(s => s.id === p.creditCardId);
    return card ? Math.max(0, Number(card.usedCredit) || 0) : null;
  }
  if (p.paymentType === 'debt') {
    const debt = debts.find(d => d.id === p.debtId);
    if (!debt) return null;
    // Kỳ cuối phải trả cả gốc còn lại lẫn lãi của kỳ đó
    const remaining = Math.max(0, Number(debt.remainingBalance) || 0);
    return remaining + Math.round(remaining * (Number(debt.interestRate) || 0) / 100 / 12);
  }
  return null;
};

/** Số tiền sẽ thực sự phải trả: nhỏ hơn giữa số dự kiến và số còn nợ. */
export const cappedPayment = (amount: number, cap: number | null): number => (cap === null ? amount : Math.min(amount, cap));

const vnd = (n: number) => `${Math.round(n).toLocaleString('vi-VN')} đ`;
/**
 * Nguồn thanh toán có đủ để chi `amount` không? Khớp chính sách sổ cái: thẻ không được vượt hạn mức,
 * ví ngân hàng/tiết kiệm không được âm, ví tiền mặt cho âm. Trả thông điệp lỗi hoặc null nếu ổn.
 * Chỉ dùng cho khoản CHI/TRẢ (tiền ra khỏi nguồn), không dùng cho khoản thu.
 */
export const fundingIssue = (wallet: { name?: string; type?: string; balance?: number; usedCredit?: number; creditLimit?: number } | undefined, amount: number): string | null => {
  if (!wallet || !(amount > 0)) return null;
  const name = wallet.name ?? 'ví';
  if (wallet.type === 'credit') {
    const limit = Number(wallet.creditLimit) || 0;
    if (!(limit > 0)) return null;
    const used = Number(wallet.usedCredit) || 0;
    const avail = Math.max(0, limit - used);
    return amount > avail ? `Thẻ "${name}" chỉ còn khả dụng ${vnd(avail)} (hạn mức ${vnd(limit)}, đã dùng ${vnd(used)}), khoản này cần ${vnd(amount)}. Chọn ví khác, hoặc ghi khoản trả thẻ trước rồi xác nhận lại.` : null;
  }
  if (wallet.type === 'cash') return null;
  const bal = Number(wallet.balance) || 0;
  return amount > bal ? `Ví "${name}" chỉ còn ${vnd(bal)}, khoản này cần ${vnd(amount)}. Chọn ví khác, hoặc chuyển thêm tiền vào ví trước.` : null;
};
